/**
 * 格式化图片
 * @param {} fileName 
 * @returns 
 */
function formatFile(fileName) {
	console.log(process.env.VUE_APP_BASE_IMG_URL)
	if (!fileName) return '';
	if (fileName.indexOf('http') == -1) {
		return String(process.env.VUE_APP_BASE_IMG_URL + fileName)
	} else {
		return fileName
	}
}

/**
 * 格式化数字，保留两位小数
 * 解决数字精度丢失问题
 */
function formatNumber(num) {
	return Math.round(num * Math.pow(10, 2)) / Math.pow(10, 2);
}

// 格式化金额
function formatMoney(amount) {
	amount = Number(amount);
	let formattedAmount = 0

	if (amount >= 10000) {
		formattedAmount = formatNumber((amount / 10000)) + '万';
	}
	else if (amount >= 1000) {
		formattedAmount = formatNumber((amount / 1000)) + '千';
	}
	else {
		formattedAmount = '￥' + formatNumber(amount);
	}
	return formattedAmount;

}

export default {
	formatFile,
	formatMoney
}